import ReactDOM from 'react-dom'
import React from 'react'
import { ITooltip, Tooltip } from 'react-tooltip'

/* A simple wrapper around ReactTooltip to render tooltips into the shared portal root */
const MlcTooltip = (props: ITooltip) => {
    const tooltipRoot = document.getElementById('tooltip-root')

    return tooltipRoot ? ReactDOM.createPortal(<Tooltip {...props} />, tooltipRoot) : null
}

export default MlcTooltip
